export default function Privacy() {
  return (
    <main className="w-full bg-white min-h-screen pt-40 pb-24 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-transparent to-white pointer-events-none" />
      <div className="container mx-auto px-6 md:px-12 max-w-4xl relative z-10">
        <div className="mb-12 border-b border-border pb-8">
          <span className="font-mono text-primary text-sm tracking-[0.3em] uppercase block mb-4">
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-light text-foreground">
            Privacy <span className="font-bold">Policy</span>
          </h1>
        </div>
        
        <div className="prose prose-p:text-muted-foreground prose-p:leading-relaxed prose-headings:font-bold prose-headings:text-foreground prose-a:text-primary hover:prose-a:text-primary/80 max-w-none">
          <p>Last updated: {new Date().getFullYear()}</p>
          
          <p>
            Plasmics GmbH ("we", "us", or "our") operates the Plasmics website (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
          </p>

          <h2>1. Information Collection and Use</h2>
          <p>
            We collect several different types of information for various purposes to provide and improve our Service to you.
          </p>

          <h3>Types of Data Collected</h3>
          <h4>Personal Data</h4>
          <p>
            While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
          </p>
          <ul>
            <li>Email address (e.g., when subscribing to our newsletter)</li>
            <li>First name and last name</li>
            <li>Cookies and Usage Data</li>
          </ul>

          <h4>Usage Data</h4>
          <p>
            We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
          </p>

          <h2>2. Use of Data</h2>
          <p>Plasmics GmbH uses the collected data for various purposes:</p>
          <ul>
            <li>To provide and maintain the Service</li>
            <li>To notify you about changes to our Service</li>
            <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
            <li>To provide customer care and support</li>
            <li>To provide analysis or valuable information so that we can improve the Service</li>
            <li>To monitor the usage of the Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>

          <h2>Newsletter subscriptions</h2>
          <p>
            If you choose to subscribe, we store your email address, your consent, when you gave it, and that
            it came from the homepage signup form. We use this information to manage your request to receive
            Plasmics email updates. You can request removal of your subscription by emailing{' '}
            <a href="mailto:office@plasmics.com">office@plasmics.com</a>.
          </p>

          <h2>3. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us via the forms provided on our website.
          </p>
        </div>
      </div>
    </main>
  );
}
